import EntityBusinessLayerList from './EntityBusinessLayerList';

export default EntityBusinessLayerList;
